import type { ProfileWizardStepConfig } from './ProfileWizardCard.types';
import { PROFILE_WIZARD_STEP } from './ProfileWizardCard.types';

export const STEP_CIRCLE_SIZE = 40;

export const PROFILE_WIZARD_STEP_ORDER = [
  PROFILE_WIZARD_STEP.phoneNumber,
  PROFILE_WIZARD_STEP.birthday,
  PROFILE_WIZARD_STEP.address,
] as const;

export const PROFILE_WIZARD_STEP_CONFIGS: ReadonlyArray<ProfileWizardStepConfig> = [
  {
    description:
      'We use this to send task updates and to expedite details when contacting service providers on your behalf.',
    icon: 'IconPhone',
    step: PROFILE_WIZARD_STEP.phoneNumber,
    title: "What's your phone number?",
  },
  {
    description: 'This helps us personalize your experience and handle age-related tasks on your behalf.',
    icon: 'IconCake',
    step: PROFILE_WIZARD_STEP.birthday,
    title: "What's your birthday?",
  },
  {
    description: 'This lets us customize suggestions for your area and make sure deliveries go to the right place.',
    icon: 'IconGps',
    step: PROFILE_WIZARD_STEP.address,
    title: "What's your address?",
  },
];
